<template>
	<div v-if="textData.length > 0" class="modalTipsTextComponent displayF columnGap12 borderRadius2">
		<div class="flexShrink0 displayFCenter height18">
			<img :src="initThemeImg(theme, 'modalTipsTextComponentImg@2x')" alt="" class="imgWH12 marginTop1" />
		</div>
		<div>
			<div v-for="(item, i) in textData" :key="i" class="displayF flex1 fontSize12 lineHeight18 "
				:class="i + 1 == textData.length ? '' : 'marginBottom6'">
				<div class="spotBloSty borderRadius05 marginTop8"></div>
				<div class="marginLeft6">{{item}}</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		initThemeImg
	} from '@/utils/common.js'
	import useUserStore from '@/store/modules/user'

	const props = defineProps({
		textData: {
			type: Array,
			default: () => []
		}
	})

	const {
		proxy
	} = getCurrentInstance()

	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	.modalTipsTextComponent {
		padding: 8px 16px;
		@include color('modal_tips_text_color');
		@include background('modal_tips_text_par_back');

		.spotBloSty {
			width: 3px;
			height: 3px;
			@include background('modal_tips_text_color');
		}
	}
</style>